
const contData = [
    {
        "module": "Módulo 1 - Introdução",
        "topics": [
            "1 - Boas-vindas",
            "2 - Estrutura do Curso"
        ]
    },
    {
        "module": "Módulo 2 - Tratamento dos dados",
        "topics": [
            "3 - Ferramentas",
            "4 - Tabelas",
            "5 - Limpeza de dados",
            "6 - Tipos de dados"
        ]
    },
    {
        "module": "Módulo 3 - O Looker Studio",
        "topics": [
            "7 - Criação conta e Importação de dados",
            "8 - Visão dos dados",
            "9 - Gráfico de Totais",
            "10 - Gráfico Pizza/Pie",
            "11 - Gráfico de Colunas parte 1",
            "12 - Gráfico de Colunas part 2",
            "13 - Período, Dimensão e Métrica",
            "14 - Gráfico de Barras e Tabelas Simples",
            "15 - Estilos dos Gráficos"
        ],
    },
    {
        "module": "Módulo 4 - 1º Estudo de Caso",
        "topics": [
            "16 - Gráfico, Dashboard e Relatório",
            "17 - Fontes de Dados Básicas",
            "18 - Convertendo um arquivo CSV",
            "19 - Iniciando o Projeto",
            "20 - Gráfico de Série Temporal",
            "21 - Linha de Referência",
            "22 - Controle dos Períodos",
            "23 - Gráfico de Série Temporal Suavizada",
            "24 - Gráficos de Colunas Empilhadas",
            "25 - Filtros",
            "26 - Gráficos de Barras Empilhadas",
            "27 - Tabela com Mapa de Calor",
            "28 - Gráfico de Colunas com 2 Métricas",
            "29 - Gestão de Páginas do Relatório",
            "30 - Editando o Tema do Dashboard"
        ],
    },
    {
        "module": "Módulo 5 - Trabalhando com Mapas",
        "topics": [
            "31 - Texto, Imagem e Formas",
            "32 - 2º Estudo de Caso",
            "33 - Gráficos de Combinação",
            "34 - Tabelas Dinâmicas",
            "35 - Dinâmicas com Barras e Calor",
            "36 - Tipos de Dados Geográficos",
            "37 - Mapas - Balão e Preenchido",
            "38 - Gráfico de Área",
            "39 - Gráfico Medidor",
            "40 - Gráfico de Linhas",
            "41 - Layout e Temas",
            "42 - Finalizando 2º Estudo de Caso",
            "43 - Compartilhar e Incorporar Dashboard",
        ],
    },
    {
        "module": "Módulo 6 - Manipulando Dados",
        "topics": [
            "44 - Novas Fontes de Dados",
            "45 - Múltiplas Fontes de Dados",
            "46 - Combinar Dados",
            "47 - join: left, right, inner, full ou cross join",
            "48 - Adicionar novo campo aos dados",
            "49 - Adicionar Parâmetros",
            "50 - Básico de Funções",
            "51 - 3º Estudo de Caso"

        ],
    },
    {
        "module": "Módulo 7 - Outros Gráficos",
        "topics": [
            "52 - Escolha do Gráfico",
            "53 - 4º Estudo de Caso",
            "54 - Gráfico de Dispersão",
            "55 - Gráfico de Árvore",
            "56 - Gráfico de Cascata",
            "57 - Sankey",
            "58 - Boxplot",
            "59 - Próximos Passos"
        ],
    },
    {
        "module": "Módulo 8 - Bônus e Certificado",
        "topics": [
            "59 - Dicas de Planilha Google",
            "60 - Dicas Power BI",
            "61 - Emissão do Certificado"
        ],
    },


]
export default contData;
